import 'slick-slider';
import './changeFontSize';
export * from './comments';
import {share} from './social';

export * from './gallery';

jQuery(document).ready(($) => {
    let $title = $('h1');

    let $social = $('.social .social-sticky');

    let bottom = $title.position().top + $title.outerHeight(true);

    $social.css('margin-top', `${bottom}px`);

    $('.social-sticky .social-icon').on('click', function () {
        let medium = $(this).attr('id');
        let link = location.href;
        sport1Analytics.sendEvent('article-page', 'share-click', medium);
        share(link, medium);
    });

    window.addEventListener('message', function (e) {
        const data = e.data;
        if (typeof(data) === 'string' && data.includes("height")) {
            const decoded = JSON.parse(data);
            if (decoded.height && +decoded.height > 0) {
                console.log(decoded);
                $("#iframeWrapper").height(`${decoded.height}px`);
            }
        }
    });


    $('.author').on('click',function () {
        sport1Analytics.sendEvent('article-page', 'reporter-click', 'reporter-name-picture');
    })

    $(document).on('click', '#vod_widget .video-card .video-link', function () {
        let label = $('.title-text', this).text();
        sport1Analytics.sendEvent('article-page', 'briefs-click', label);
    });


    $(document).on('click', '#vod_widget .vod-widget-footer a', function () {
        let label = 'more';
        sport1Analytics.sendEvent('article-page', 'briefs-more-click', label);
    });

    $(document).on('click', '#table_widget .table-widget-footer a', function () {
        let label = 'more';
        sport1Analytics.sendEvent('article-page', 'table-more-click', label);
    });

    $(document).on('click', '#table_widget .team-name', function () {
        let label = $(this).text();
        sport1Analytics.sendEvent('article-page', 'table-team-click', label);
    });

    $(document).on('click', '#games_widget .games-widget-header', function () {
        sport1Analytics.sendEvent('article-page', 'game-board-name', 'league-board-name');
    });

    $(document).on('click', '#games_widget .game', function () {

        let teams = $('.comp-name', this).map(function () {
            return $(this).text();
        });

        let label = teams.toArray().join(' - ');

        sport1Analytics.sendEvent('article-page', 'game-board-click', label);
    });

    $(document).on('click', '#scorers_widget .scorer-info', function () {
        let label = $('.scorer-name', this).text();
        sport1Analytics.sendEvent('article-page', 'king-of-goals-click', label);
    });

    $(document).on('click', '#scorers_widget .scorers-widget-header', function () {
        sport1Analytics.sendEvent('article-page', 'king-of-goals-table', 'king-of-the-goals-league');
    });


    $(document).on('click', '#teams_widget .team', function () {
        let label = $('.team-name').text();
        sport1Analytics.sendEvent('article-page', 'teams-in-league-click', label);
    });

    $(document).on('click', '#teams_widget .teams-widget-header', function () {
        sport1Analytics.sendEvent('article-page', 'teams-in-league-table', 'league-name');
    });


});